module.exports = __webpack_public_path__ + "img/JBI_banner_es.882b10dc.png";